import { yupResolver } from "@hookform/resolvers/yup";
import { Stack, Typography, useTheme } from "@mui/material";
import { Input, RadioButtonGroup, SelectField } from "components";
import { useGetAllBoards, useGlobalStore } from "controller";
import { forwardRef, useImperativeHandle } from "react";
import { useForm } from "react-hook-form";
import { debugConsole } from "utilz/helpers";
import * as yup from "yup";
const schema = yup.object({
  display_from: yup.string(),
  board: yup.string().nullable().notRequired(),
  custom_display_name: yup
    .string()
    .nullable()
    .notRequired()
    .test({
      name: "compare",
      message: "Name is required",
      test: (value, context) => {
        return !(
          context.parent.display_from === "custom_name" &&
          (!value || (value && value.trim().length <= 0))
        );
      },
    }),
});

export const MailBoxSection = forwardRef(
  (
    {
      selectedResources,
      board,
      onSelectAssigneeClicked,
      onRemoveAssigneeClicked,
      customDisplayName,
      displayFrom,
    }: {
      selectedResources: Array<any>;
      board?: string;
      displayFrom?: string;
      customDisplayName?: string;
      onSelectAssigneeClicked?: () => void;
      onRemoveAssigneeClicked?: (mappingId: string) => void;
    },
    ref,
  ) => {
    const theme = useTheme();

    const defaultTicketBoard = useGlobalStore(
      (state) => state.generalConfig?.defaultTicketBoardId,
    );
    const {
      control,
      watch,
      handleSubmit,
      formState: { errors },
    } = useForm({
      resolver: yupResolver(schema),
      defaultValues: {
        display_from: displayFrom || "msp",
        custom_display_name:
          displayFrom === "custom_name" ? customDisplayName || "" : "",
        board: board || defaultTicketBoard || null,
      },
    });

    const { data: boards } = useGetAllBoards({ serviceType: "ticket_board" });
    const displayNameType = watch("display_from");

    const submit = async () => {
      let data;
      await handleSubmit(
        ({ board, display_from, custom_display_name }) => {
          data = {
            board,
            display_from,
            custom_display_name:
              display_from === "custom_name" ? custom_display_name : "",
          };
        },
        (err) => {
          debugConsole(err);
        },
      )();
      return data;
    };

    useImperativeHandle(ref, () => ({ submit }));

    return (
      <Stack
        gap="16px"
        sx={{
          width: "100%",
          height: "100%",
          borderRadius: "8px",
        }}
      >
        <Stack
          sx={{
            bgcolor: "#FFFF",
            p: "24px",
            gap: "24px",
            borderRadius: "8px",
            // height: "100%",
            border: `1px solid ${theme.palette.neutral["015"]}`,
          }}
        >
          <Stack gap="24px">
            <Stack gap="8px">
              <Typography variant="h6">Display Name</Typography>
              <Typography variant="body-small" color="lightBg.low">
                Choose how your support mailbox name will appear in customer
                emails.
              </Typography>
            </Stack>
            <RadioButtonGroup
              row={true}
              name="display_from"
              control={control}
              RadioGroupProps={{
                ml: "8px",
                gap: "12px",
              }}
              data={[
                {
                  label: "Company Name",
                  value: "msp",
                },
                { label: "Technician Name", value: "technician" },
                { label: "Custom Name", value: "custom_name" },
              ]}
              labelMappingKey={"label"}
              valueMappingKey={"value"}
              radioButtonContainerStyle={{
                gap: "8px",
                ...theme.typography["body-large"],
              }}
              radioButtonStyle={{
                py: "0",
                px: "0",
              }}
            />

            {displayNameType == "custom_name" && (
              <Stack>
                <Input
                  label="Enter Mail Box Name Here"
                  name="custom_display_name"
                  required
                  control={control}
                  fullWidth
                  error={errors?.custom_display_name ? true : false}
                  errorMessage={errors?.custom_display_name?.message}
                  inputProps={{ maxLength: 100 }}
                />
              </Stack>
            )}
          </Stack>
        </Stack>
        {/* 3rd block */}
        <Stack
          sx={{
            bgcolor: "#FFFF",
            p: "24px",
            gap: "24px",
            borderRadius: "8px",
            border: `1px solid ${theme.palette.neutral["015"]}`,
          }}
        >
          <Stack gap="8px">
            <Typography variant="h6">Ticket Board</Typography>
            <Typography variant="body-small" color="lightBg.low">
              Select the board where all emails from this mailbox will be
              converted into tickets. This helps keep tickets organized.
            </Typography>
          </Stack>
          {
            //Select Board and Assignees
          }
          <Stack
            direction="row"
            gap="16px"
            alignItems={"center"}
            sx={{ Height: "100%", width: "100%" }}
          >
            <Stack flex={1}>
              <SelectField
                name="board"
                label="Board"
                control={control}
                options={boards?.result}
                valueMappingKey="ticket_board_id"
                labelMappingKey="ticket_board_name"
                isSearchable
                error={errors.board ? true : false}
                errorMessage={errors.board?.message}
                searchFieldProps={{
                  placeholder: "Search board",
                }}
              />
            </Stack>
            <Stack flex={1} sx={{ marginTop: "-4px" }}>
              {/* <Button
                loading={false}
                variant="secondary"
                onClick={onSelectAssigneeClicked}
                sx={{
                  px: "24px",
                }}
              >
                Select Assignees
              </Button> */}
            </Stack>
          </Stack>

          {/* <Stack
            direction={"row"}
            sx={{
              flexWrap: "wrap",
              gap: "8px",
            }}
          >
            {selectedResources.map((resource: any, index: number) => (
              <Stack
                direction={"row"}
                key={resource?.mapping_id}
                sx={{
                  gap: "8px",
                  alignItems: "center",
                  p: "4px 12px 4px 8px",
                  border: `1px solid ${theme.palette.neutral["015"]}`,
                  borderRadius: "4px",
                }}
              >
                <Avatar
                  fullname={getFullName(
                    resource?.first_name,
                    "",
                    resource?.last_name
                  )}
                  src={resource?.profile_image}
                  sx={{
                    width: "24px",
                    height: "24px",
                  }}
                ></Avatar>
                <Typography variant="body-small">
                  {getFullName(resource?.first_name, "", resource?.last_name)}
                </Typography>
                <CloseIcon
                  sx={{
                    cursor: "pointer",
                  }}
                  onClick={() =>
                    onRemoveAssigneeClicked?.(resource?.mapping_id)
                  }
                />
              </Stack>
            ))}
          </Stack> */}
        </Stack>
      </Stack>
    );
  },
);
